module.exports = __webpack_public_path__ + "static/img/szhwq.221e314.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/szhwq.jpg
// module id = 24z0
// module chunks = 1